module.exports = __webpack_public_path__ + "static/media/crypto-pay-final-step.de828843.png";